export const Colors = {
  primary: "#1890ff",
  success: "#4e9409",
  danger: "#f5222d",
  grey: "#A9A9A9",
  warning: "#da9711",
  darkGrey: "#424242",
  darkRed: "#ee2a00",
};
